// heic-viewer.component.ts
import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import heic2any from 'heic2any';

@Component({
  selector: 'app-heic-viewer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="viewer-container">
      <button class="close-btn" (click)="close()">✕</button>
      <img *ngIf="convertedUrl" [src]="convertedUrl" class="viewer-image" />
      <p *ngIf="!convertedUrl" class="loading-text">Loading image...</p>
    </div>
  `,
  styles: [`
    .viewer-container {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #121212;
      overflow: hidden;
    }
    .viewer-image {
      max-width: 90%;
      max-height: 90%;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.5);
    }
    .loading-text {
      color: #fff;
      font-size: 16px;
    }
    .close-btn {
      position: absolute;
      top: 16px;
      right: 16px;
      background: rgba(0,0,0,0.6);
      color: #fff;
      border: none;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      font-size: 20px;
      cursor: pointer;
      z-index: 10;
      transition: background 0.3s;
    }
    .close-btn:hover {
      background: rgba(255,255,255,0.8);
      color: #000;
    }
  `]
})
export class HiecViewerComponent implements AfterViewInit {
  convertedUrl: string | null = null;

  constructor(
    private el: ElementRef,
    private dialogRef: MatDialogRef<HiecViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { heicFile: File | string }
  ) {}

  async ngAfterViewInit() {
    try {
      let blob: Blob;

      if (typeof this.data.heicFile === 'string') {
        const response = await fetch(this.data.heicFile);
        const arrayBuffer = await response.arrayBuffer();
        const file = new File([arrayBuffer], 'image.heic', { type: 'image/heic' });
        blob = await heic2any({ blob: file, toType: 'image/jpeg' }) as Blob;
      } else {
        blob = await heic2any({ blob: this.data.heicFile, toType: 'image/jpeg' }) as Blob;
      }

      this.convertedUrl = URL.createObjectURL(blob);
    } catch (err) {
      console.error('HEIC conversion error:', err);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
